import { createAsyncThunk } from "@reduxjs/toolkit"
import { allProjetsApi } from "../../services/Api/Projet"

export const fetchProjects = createAsyncThunk('project/getAllProjects', async () => {
  const response = await allProjetsApi()
  return response.json()
})